import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  useMediaQuery,
} from "@mui/material";
import BlueButton from "../../../components/BlueButton/BlueButton";
import Facebook from "./../../../assets/facebook-img.svg";
import Instgram from "./../../../assets/instgram-img.svg";
import X from "./../../../assets/x-img.svg";
import Youtube from "./../../../assets/youtube-img.svg";
import Whats from "./../../../assets/whats-img.svg";
import Telegram from "./../../../assets/telegarm-img.svg";
import api from "../../../utils/api";

const Links = () => {
  const isMobile = useMediaQuery("(max-width:767px)");

  // State to store social media links
  const [socialMedia, setSocialMedia] = useState([
    { id: 1, link: "", type: "facebook" },
    { id: 2, link: "", type: "instagram" },
    { id: 3, link: "", type: "x" },
    { id: 4, link: "", type: "youtube" },
    { id: 5, link: "", type: "whatsapp" },
    { id: 6, link: "", type: "telegram" },
  ]);

  // Loading state
  const [loading, setLoading] = useState(false);

  // Fetch social media links on component mount
  useEffect(() => {
    fetchSocialMedia();
  }, []);

  // Function to fetch social media links from API
  const fetchSocialMedia = async () => {
    try {
      setLoading(true);
      const res = await api.get("/socialMedia");

      if (res.data && res.data.data) {
        setSocialMedia(res.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch social media links:", error);
      // You can integrate with your react-notify library here
    } finally {
      setLoading(false);
    }
  };

  // Function to update social media links
  const updateSocialMedia = async () => {
    try {
      setLoading(true);

      // The API expects form-data format based on the screenshot
      const formData = new FormData();

      // Add each social media item as separate form fields
      socialMedia.forEach((item) => {
        formData.append(`link[]`, item.link);
        formData.append(`type[]`, item.type);
        // Only append id if it exists
        if (item.id) {
          formData.append(`id[]`, item.id);
        }
      });

      // Send as form-data
      const res = await api.post("/update-socialMedia", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data && res.data.status === 200) {
        // You can integrate with your react-notify library here for success notification
      }
    } catch (error) {
      console.error("Failed to update social media links:", error);
      // You can integrate with your react-notify library here for error notification
    } finally {
      setLoading(false);
    }
  };

  // Handle input change for social media links
  const handleLinkChange = (id, value) => {
    setSocialMedia((prev) =>
      prev.map((item) => (item.id === id ? { ...item, link: value } : item))
    );
  };

  // Get link by type
  const getLinkByType = (type) => {
    const socialMediaItem = socialMedia.find((item) => item.type === type);
    return socialMediaItem ? socialMediaItem.link : "";
  };

  // Get id by type
  const getIdByType = (type) => {
    const socialMediaItem = socialMedia.find((item) => item.type === type);
    return socialMediaItem ? socialMediaItem.id : null;
  };

  return (
    <div className="departments-container ">
      <form action="" className="links-container">
        <div className="control-group">
          <img src={Facebook} alt="" />
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="outlined-adornment-password"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رابط الفيس بوك
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              required
              id="outlined-adornment-password"
              type="text"
              value={getLinkByType("facebook")}
              onChange={(e) =>
                handleLinkChange(getIdByType("facebook"), e.target.value)
              }
            />
          </FormControl>
        </div>

        <div className="control-group">
          <img src={Instgram} alt="" />
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="outlined-adornment-password"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رابط الانستجرام{" "}
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              required
              id="outlined-adornment-password"
              type="text"
              value={getLinkByType("instagram")}
              onChange={(e) =>
                handleLinkChange(getIdByType("instagram"), e.target.value)
              }
            />
          </FormControl>
        </div>

        <div className="control-group">
          <img src={X} alt="" />
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="outlined-adornment-password"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رابط اكس{" "}
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              required
              id="outlined-adornment-password"
              type="text"
              value={getLinkByType("x")}
              onChange={(e) =>
                handleLinkChange(getIdByType("x"), e.target.value)
              }
            />
          </FormControl>
        </div>

        <div className="control-group">
          <img src={Youtube} alt="" />
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="outlined-adornment-password"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رابط اليوتيوب{" "}
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              required
              id="outlined-adornment-password"
              type="text"
              value={getLinkByType("youtube")}
              onChange={(e) =>
                handleLinkChange(getIdByType("youtube"), e.target.value)
              }
            />
          </FormControl>
        </div>

        <div className="control-group">
          <img src={Whats} alt="" />
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="outlined-adornment-password"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رابط الواتساب{" "}
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              required
              id="outlined-adornment-password"
              type="text"
              value={getLinkByType("whatsapp")}
              onChange={(e) =>
                handleLinkChange(getIdByType("whatsapp"), e.target.value)
              }
            />
          </FormControl>
        </div>

        <div className="control-group">
          <img src={Telegram} alt="" />
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="outlined-adornment-password"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رابط تيلجرام{" "}
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              required
              id="outlined-adornment-password"
              type="text"
              value={getLinkByType("telegram")}
              onChange={(e) =>
                handleLinkChange(getIdByType("telegram"), e.target.value)
              }
            />
          </FormControl>
        </div>
      </form>

      <div className="action-continer">
        <BlueButton
          text={loading ? "جاري الحفظ..." : "حفظ"}
          variant="fill"
          size="medium"
          onClick={updateSocialMedia}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default Links;
